let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("fZrr5")]).then(() => parcelRequire('btHFe'));